import styled from 'styled-components'
import { Label } from 'semantic-ui-react'

/**
 * Styled Error Label
 * Extends Semantic UI Label with custom positioning and border styling
 * Positions error ABOVE field with downward-pointing arrow (matching original V1)
 */
export const StyledErrorLabel = styled(Label)`
  /* Double ampersand for higher specificity than Semantic UI */
  && {
    position: absolute !important;
    top: -1em !important;
    left: 30% !important; /* Position at LEFT edge */
    right: auto !important; /* Override Semantic UI right positioning */
    white-space: nowrap !important; /* Prevent text wrapping (from V1) */
    overflow: visible !important; /* Ensure arrow visible (from V1) */
    border-right: 0 !important;
    border-left: 0 !important;
    border-radius: 0 !important;
    font-weight: 700 !important;
  }

  /* CRITICAL: Position the pointing arrow on the left (matches V1) */
  &&:before {
    left: 1em !important;
  }
`
